<template>
	<div class="fb-share-link">
		<a :href="link" title="Facebook" @click="share(link)" data-share="facebook"><i class="fa fa-facebook"></i></a>
	</div>
</template>

<script type="text/javascript">
export default{
	name: 'FacebookShare',
	props: ['href'],
	data: function(){
		return {
			link: 'https://www.facebook.com/dialog/share?app_id=145634995501895&display=popup&href='+this.href
		}
	},
	methods: {
		share : function(link){

			var config = {
				width: 280,
				height: 280,
				left: (screen.width - 280) / 2,
				top: (screen.height - 280) / 2
			}

			var fbWindow = window.open(link, '', 'width='+config.width+',height='+config.height+',left=60,top='+config.top)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/share/FacebookShare.vue